import script from "./AffiliateLogin.vue?vue&type=script&setup=true&lang=js"
export * from "./AffiliateLogin.vue?vue&type=script&setup=true&lang=js"

import "./AffiliateLogin.vue?vue&type=style&index=0&id=9f82abba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9f82abba"]])

export default __exports__